module.exports = __webpack_public_path__ + "img/interpackmaxi_cod_dg_k.80d72df0.png";